const Desc = `photoshopActions: SelectSubjectMask.atn in aws. ${new Error('To get file path').stack.split('\n')[1].match(/Object(.+)\(https/)[1] || ''}`

const Payload = {
    inputs: [
        {
            href: 'https://skycity-asset.adobedice.com/testing/pits/input/dancer.jpg',
            storage: 'external'
        }
    ],
    options: {
        actions: [
            {
                href: 'https://skycity-asset.adobedice.com/testing/pits/atn/SelectSubjectMask.atn',
                storage: 'external'
            }
        ]
    },
    outputs: [
        {
            storage: 'adobe',
            type: 'image/png',
            overwrite: true,
            width: 300,
            compression: 'large'
        }
    ]
}

module.exports = { Payload, Desc }
